/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CookieLaw          from 'vue-cookie-law';
import Teleport           from 'vue2-teleport';

import ApplicationState   from 'store/application';
import Panel              from 'g3w-panel';
import Component          from 'g3w-component';
import GUI                from 'services/gui';

import { getUniqueDomId } from 'utils/getUniqueDomId';
import { promisify }      from 'utils/promisify';
import { sameOrigin }     from 'utils/sameOrigin';
import { waitFor }        from 'utils/waitFor';

import userMessage        from 'components/UserMessage.vue';
import CatalogContextMenu from 'components/CatalogContextMenu.vue';
import ModalLogin         from 'components/ModalLogin.vue';
import ModalAddlayer      from 'components/ModalAddLayer.vue';
import ModalChangemap     from 'components/ModalChangeMap.vue';
import ModalMetadata      from 'components/ModalMetadata.vue';
import { gettext as _ }   from 'g3w-i18n';

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'app',

  data() {
    return {
      iframe:                false,
      language:              null,
      cookie_law_buttonText: _('Got It!'),
      app:                   ApplicationState,
      state:                 ApplicationState.viewport,
      updatePreviousTitle:   false,
      header:                _('main navigation'),
      custom_links:          (window.initConfig.header_custom_links || []).concat(ApplicationState.navbaritems).filter(Boolean).map(l => Object.assign(l, { id: l.id || getUniqueDomId() })),
    }
  },

  components: {
    CookieLaw,
    userMessage,
    CatalogContextMenu,
    ModalLogin,
    ModalAddlayer,
    ModalChangemap,
    ModalMetadata,
    Teleport,
  },

  computed: {

    languages() {
      const languages = (Array.isArray(this.appconfig.i18n) && this.appconfig.i18n || []).sort((a, b) => a[0].localeCompare(b[0]));
      return languages.length > 1 && languages;
    },

    dropdownParent() {
      return window.innerWidth >= 768;
    },

    appconfig() {
      return window.initConfig;
    },

    isIframe() {
      return window.top !== window.self;
    },

    urls() {
      return this.appconfig.urls;
    },

    logo_url() {
      return ApplicationState.project.state.thumbnail || `${this.appconfig.mediaurl}${window.initConfig.header_logo_img}`;
    },

    project_title() {
      return ApplicationState.project.getState().name;
    },

    user() {
      return (this.appconfig.user && this.appconfig.user.username) ? this.appconfig.user : null;
    },

    login_url() {
      return this.appconfig.user.login_url
    },

    /**
     * @since 3.11.0
     */
    has_iframe_login() {
      return this.login_url && ('/' === this.login_url[0] || sameOrigin(this.login_url, window.location.href));
    },

    /**
     * @returns {boolean} whether it should list any related projects or maps.
     *
     * @since 3.8.0
     */
    hasRelatedMaps() {
      return this.appconfig.macrogroups.length + this.appconfig.groups.length + this.appconfig.projects.length > 1;
    },

    main_title() {
      const main_title = this.appconfig.main_map_title;
      const group_name = this.appconfig.title || this.appconfig.slug;
      return main_title ? `${main_title} - ${group_name}` : group_name;
    },

    breadcrumb() {
      return this.state.content.contentsdata
        .filter(c => c.options.crumb)
        .map(c => c.options.crumb);
    },

    has_panel() {
      const panel = ApplicationState.gui.layout[ApplicationState.gui.layout.__current].rightpanel;
      return (panel.width_100 || panel.height_100) ? false : ('h' === this.state.split ? panel.width : panel.height) > 0;
    },

    usermessage() {
      return this.state.usermessage;
    },

    showtitle() {
      if (this.state.content.contentsdata.length > 0) {
        const options = this.state.content.contentsdata[this.state.content.contentsdata.length - 1].options;
        if ( [true, false].includes(options.showtitle) ) { return options.showtitle }
      }
      return true;
    },

    styles() {
      return {
        map: {
          width:         `${this.state.map.sizes.width}px`,
          height:        `${this.state.map.sizes.height}px`,
        },
        content: {
          width:         `${this.state.content.sizes.width}px`,
          height:        `${this.state.content.sizes.height}px`,
        },
      }
    },

    contentTitle() {
      if (this.state.content.contentsdata.length) {
        const { title, post_title, text = false } = this.state.content.contentsdata[this.state.content.contentsdata.length - 1].options;
        return { title, post_title, text };
      }
    },

    backOrBackTo() {
      return (this.state.content.contentsdata.length > 1 && this.state.content.showgoback)
        ? !(this.state.content.contentsdata[this.state.content.contentsdata.length - 2].options.title)
          ? 'back'
          : 'backto'
        : false;
    },

    previousTitle() {
      const title = (this.state.content.contentsdata.length > 1 && this.state.content.showgoback)
        ? this.state.content.contentsdata[this.state.content.contentsdata.length - 2].options.title
        : null;
      this.updatePreviousTitle = true;
      this.$nextTick(() => this.updatePreviousTitle = false);
      return title;
    },

    title() {
      return ApplicationState.sidebar.title;
    },

    disabled() {
      return ApplicationState.gui.sidebar.disabled;
    },

    panels() {
      return ApplicationState.sidebar.contentsdata;
    },

    showmainpanel() {
      return ApplicationState.sidebar.components.length > 0 && !this.panels.length;
    },

    componentname() {
      return ApplicationState.sidebar.components.length ? ApplicationState.sidebar.components.slice(-1)[0].getTitle(): '';
    },

    panelname() {
      return this.panels.length ? this.panels.slice(-1)[0].content.getTitle() : '';
    },

  },

  methods: {

    /**
     * @since 3.11.0
     */
    onCustomItemClick(e, item) {
      if (item.onclick) {
        e.preventDefault();
        return item.onclick();
      }
      if (!['modal', 'metadata'].includes(item.type)) {
        return;
      }
      e.preventDefault();
      if (item.target && 'modal' === item.type && document.querySelector(item.target)) {
        return $(item.target).modal('show');
      }
      if (item.target && 'metadata' === item.type && document.querySelector('#modal-metadata')) {
        $('#modal-metadata').modal('show');
        document.querySelector('#modal-metadata a[href="' + item.target + '"]').click();
        return;
      }
      $('body').append(/* html */`
        <div id = "custom_modal" class = "modal fade" tabindex="-1">
          <div class = "modal-dialog">
            <div class  = "modal-content">${ item.content }</div>
          </div>
        </div>
      `);
      $('#custom_modal').modal('show');
      $('#custom_modal').on('hidden.bs.modal', () => $('#custom_modal').remove());
    },

    async showEmbedModal() {
      await GUI.getPermalink(new URL(window.location.href), {});
    },

    /**
     * @since 3.11.0
     */
    showaddLayerModal() {
      if (window.innerWidth < 767) {
        GUI.hideSidebar();
      }
      $('#modal-addlayer').modal('show');
    },

    /**
     * @since 3.8.0
     */
    openChangeMapMenu() {
      if (window.innerWidth < 767) {
        GUI.hideSidebar();
      }
      $('#modal-changemap').modal('show');
    },

    isNotLastCrumb(index) {
      return index < this.breadcrumb.length - 1;
    },

    closeContent() {
      GUI.closeContent();
    },

    gotoPreviousContent() {
      GUI.popContent();
    },

    closeUserMessage() {
      GUI.closeUserMessage();
    },

    async onResize(e) {
      const sidebar = document.getElementById('g3w-view-content');
      const panel   = ApplicationState.gui.layout[ApplicationState.gui.layout.__current].rightpanel;
      let rect, dx, dy;

      this.state.content.disabled = true;

      const mousemove = e => {
        e.preventDefault();
        rect = sidebar.getBoundingClientRect();

        dx   = e.pageX - rect.left - window.scrollX;
        dy   = e.pageY - rect.top - window.scrollY;

        panel.width  = Math.min(Math.max(
          Math.round((200               / $('.content-wrapper').width())  * 100),
          Math.round(((rect.width  -dx) / $('.content-wrapper').width())  * 100),
        ), 90);

        panel.height = Math.min(Math.max(
          Math.round((200               / $('.content-wrapper').height()) * 100),
          Math.round(((rect.height -dy) / $('.content-wrapper').height()) * 100),
        ), 90);

        const viewW = $('#app')[0].getBoundingClientRect().width - $(".main-sidebar")[0].getBoundingClientRect().width - $(".main-sidebar").offset().left;
        const viewH = $(window).height() - $(".navbar").height();

        const h_split = 'h' === this.state.split;
        const v_split = 'v' === this.state.split;
        
        // percentage of secondary view (content)
        const scale = (h_split ? panel.width : panel.height) /100;

        // size "content"
        Object.assign(this.state.content.sizes, {
          width:  (h_split ?  (viewW * scale) : viewW),
          height: (v_split ? (viewH * scale) : viewH),
        });
      };

      const mouseup = async e => {
        document.removeEventListener('mousemove', mousemove);
        if (!this.disabled && 'h' === this.state.split && panel.width > 65) {
          GUI.hideSidebar();
        }
        this.state.content.disabled = false;
        GUI._layout();
      };

      document.addEventListener('mousemove', mousemove);
      document.addEventListener('mouseup', mouseup, { once: true });
    },

    resizeFull() {
      const state = ApplicationState.viewport;
      const panel = ApplicationState.gui.layout[ApplicationState.gui.layout.__current].rightpanel;
      if ('h' === state.split) {
        panel.width_100 = !panel.width_100;
      } else {
        panel.height_100 = !panel.height_100;
      }
      GUI._layout();
    },

    /**
     * @sine 4.0.0
     */
    splitContent(e) {
      const split = GUI.getCurrentContent().options.split;
      ApplicationState.viewport.split = GUI.getCurrentContent().options.split = 'v' === split ? 'h' : 'v';
      e.target.setAttribute('data-original-title', `Dock ${'h' === split ? 'right' : 'bottom'}`);
      GUI._layout();
    },

    closePanel() {
      GUI.closePanel();
    },

    async closeAllPanels() {
      ApplicationState.sidebar.title = null;
      const data = ApplicationState.sidebar.contentsdata;
      if (data.length) {
        await Promise.allSettled(data.map(async d => {
          if (d.content instanceof Component || d.content instanceof Panel) {
            await promisify(d.content.unmount());
          } else {
            $(ApplicationState.sidebar.parent).empty();
          }

        }));
        data.splice(0, data.length);
      }
    },

    /**
     * @since 3.11.0
     */
    toggleSidebar() {
      GUI.toggleSidebar();
    },

    /**
     * Toggle sidebar tree items on click
     * 
     * @since 3.11.0
     */
    toggleSidebarItem(e) {
      const mini      = document.body.classList.contains('sidebar-mini');
      const collapsed = document.body.classList.contains('sidebar-collapse');

      // open sidebar
      if (mini && collapsed) {
        GUI.showSidebar();
      }

      const li        = e.target.closest('.sidebaritem');
      const component = ApplicationState.sidebar.components.find(comp => comp.id === li.id);
      const open      = component && component.getOpen();
      const menu      = li.querySelector('.treeview-menu');

      // skip toggling element
      if (!component || (open && collapsed) || (menu && menu.contains(e.target))) {
        return;
      }

      // automatically toggle sidebar on mobile
      if (!component.collapsible && window.innerWidth <= 767) {
        GUI.toggleSidebar();
      }

      component.click({ open: !open });
    },

  },

  watch: {

    language: {
      immediate: true,
      async handler(lang) {
        if (!lang) {
          return;
        }

        // lazy load i18n translations
        try {
          _.register(lang, (await import(`${initConfig.urls.clienturl}locales/${lang}.js`)).default);
        } catch(e) {
          GUI.showUserMessage({ type: 'warning', message: e.toString(), autoclose: true });
        }

        ApplicationState.language = lang;

        history.replaceState(null, null, window.location.pathname.split('/').map((part, index) => index === 1 ? lang : part).join('/'));

        // wait until all plugins have been translated
        await waitFor(() => {
          const locale             = Object.keys(ApplicationState.locales[lang]);
          const installed_plugins  = Object.keys(initConfig.plugins);
          const i18n_plugins       = Array.from((new Set(Object.keys(ApplicationState.locales.en).filter(key => key.startsWith('plugins.')).map(key => key.split('.')[1]))));
          const translated_plugins = Array.from((new Set(locale.filter(key => key.startsWith('plugins.')).map(key => key.split('.')[1]))));
          return locale.length && installed_plugins.filter(name => i18n_plugins.includes(name)).length === translated_plugins.length;
        });

        setTimeout(() => {
          /** @since 4.0.0 */
          GUI.emit('i18n-ready', lang);
          this.cookie_law_buttonText = _('Got It!');
          //set form control class to filter
          $.extend($.fn.dataTableExt.oStdClasses, {
            "sFilterInput": "form-control search"
          });
          $.extend(true, $.fn.dataTable.defaults, {
            "language": {
              "sSearch": '',
              "searchPlaceholder": _("dosearch"),
              "sLengthMenu": _('Show _MENU_ values per page'),
              "paginate": {
                "previous": '«',
                "next": '»',
              },
              "info": _('_TOTAL_ entries'),
              "zeroRecords": _('No matching records found'),
              "infoFiltered": ''
            }
          });
        }, 500);

      },
    },

  },

  created() {
    this.language = this.appconfig.user.i18n;
  },

  async mounted() {

    this.language = this.appconfig.user.i18n;

    await this.$nextTick();

    $('#startingspinner').remove();

    document.body.classList.toggle('is-mobile', this.isMobile());
    document.body.classList.toggle('is-iframe', ApplicationState.iframe);

    if (!ApplicationState.iframe) {
      document.body.classList.add('sidebar-mini');
    }
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.app.gui.app.disabled),expression:"app.gui.app.disabled"}],staticClass:"wrapper",attrs:{"id":"app"}},[(!_vm.isIframe)?_c('nav',{ref:"navbar",staticClass:"navbar no-print",staticStyle:{"display":"flex","justify-content":"start","height":"50px"},attrs:{"role":"navigation"}},[(_vm.logo_url)?_c('a',{staticStyle:{"padding":"4px","display":"inline-block","height":"50px"},attrs:{"href":_vm.appconfig.header_logo_link || _vm.urls.frontendurl || '#',"target":_vm.appconfig.header_logo_link ? '_blank' : ''}},[_c('img',{staticStyle:{"height":"100%"},attrs:{"alt":"","src":_vm.logo_url}})]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"navbar-toggler",attrs:{"hidden":""},on:{"click":function($event){$event.preventDefault();return _vm.toggleSidebar.apply(null, arguments)}}},[_c('i',{class:_vm.$fa('bars')}),_c('b',{staticStyle:{"margin-left":"8px"}},[_vm._v("MENU")])]),_vm._v(" "),_c('hgroup',{staticClass:"project_title"},[_c('p',{staticClass:"h2"},[_vm._v(_vm._s(_vm.main_title))]),_vm._v(" "),_c('h1',[_vm._v(_vm._s(_vm.project_title))])]),_vm._v(" "),_c('ul',{staticClass:"nav-links",staticStyle:{"display":"flex","text-align":"center","white-space":"nowrap","list-style":"none","padding":"0","margin":"0"}},[_vm._l((_vm.custom_links),function(item){return _c('li',{key:item.id,class:("nav-" + (item.id)),style:({ order: item.position }),attrs:{"id":("g3w-nav-custom-links-" + (item.id))}},[_c('a',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip",value:(item.i18n ? item.title : ('&nbsp;' + item.title + '&nbsp;')),expression:"item.i18n ? item.title : ('&nbsp;' + item.title + '&nbsp;')"}],attrs:{"href":item.url || '#',"target":item.target,"data-placement":"bottom"},on:{"click":function($event){return _vm.onCustomItemClick($event, item)}}},[(item.icon)?_c('i',{class:item.icon}):_vm._e(),_vm._v(" "),(item.img)?_c('img',{attrs:{"height":"20","src":item.img,"title":item.img_title,"alt":item.img_title}}):_vm._e(),_vm._v(" "),(item.i18n)?_c('span',{directives:[{name:"t",rawName:"v-t",value:(item.text || item.title || item.img_title),expression:"item.text || item.title || item.img_title"}],attrs:{"hidden":item.text ? undefined : ''}}):_vm._e(),_vm._v(" "),(!item.i18n)?_c('span',{attrs:{"hidden":item.text ? undefined : ''},domProps:{"innerHTML":_vm._s(item.text || item.title || item.img_title)}}):_vm._e()])])}),_vm._v(" "),_c('li',{staticClass:"nav-user dropdown",attrs:{"id":"g3w-nav-account"}},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_c('i',{class:_vm.$fa('user')}),_vm._v(" "),(_vm.user)?_c('span',[_vm._v(_vm._s(_vm.user.username))]):_c('span',{directives:[{name:"t",rawName:"v-t",value:('sign_in'),expression:"'sign_in'"}]}),_vm._v(" "),_c('i',{staticClass:"triangle"})]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[(_vm.user)?_c('li',{staticClass:"user-header"},[_vm._v("\n            👋\n            "),(!_vm.user.first_name && !_vm.user.last_name)?_c('span',[_vm._v(_vm._s(_vm.user.username))]):_c('span',[_vm._v(_vm._s(_vm.user.first_name)+" "+_vm._s(_vm.user.last_name))])]):_vm._e(),_vm._v(" "),_c('li',{staticClass:"user-footer"},[(!_vm.user)?_c('a',{staticClass:"nav-login btn btn-default btn-flat skin-color",attrs:{"src":_vm.login_url,"data-toggle":_vm.has_iframe_login ? 'modal'        : undefined,"data-target":_vm.has_iframe_login ? '#modal-login' : undefined}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('sign_in'),expression:"'sign_in'"}]}),_c('i',{class:_vm.$fa('sign-in')})]):_vm._e(),_vm._v(" "),(_vm.user && _vm.user.admin_url)?_c('a',{staticClass:"nav-admin btn btn-default btn-flat skin-color",attrs:{"href":_vm.user.admin_url}},[_c('b',[_vm._v("Admin")]),_c('i',{class:_vm.$fa('tool')})]):_vm._e(),_vm._v(" "),(_vm.urls.frontendurl)?_c('a',{staticClass:"nav-home btn btn-default btn-flat skin-color",attrs:{"href":_vm.urls.frontendurl}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('homepage'),expression:"'homepage'"}]}),_c('i',{class:_vm.$fa('home')})]):_vm._e(),_vm._v(" "),(_vm.user && _vm.user.logout_url)?_c('a',{staticClass:"nav-logout btn btn-default btn-flat skin-color",attrs:{"href":_vm.user.logout_url}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('Logout'),expression:"'Logout'"}]}),_c('i',{class:_vm.$fa('sign-out')})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"nav-embedmap btn btn-default btn-flat skin-color",attrs:{"href":"#"},on:{"click":_vm.showEmbedModal}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('Embed map'),expression:"'Embed map'"}]}),_c('i',{class:_vm.$fa('share-alt')})]),_vm._v(" "),(_vm.hasRelatedMaps)?_c('a',{staticClass:"nav-changemap btn btn-default btn-flat",attrs:{"href":"#"},on:{"click":_vm.openChangeMapMenu}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('changemap'),expression:"'changemap'"}]}),_c('i',{class:_vm.$fa('refresh')})]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"nav-addlayer btn btn-default btn-flat",attrs:{"href":"#"},on:{"click":_vm.showaddLayerModal}},[_c('b',{directives:[{name:"t",rawName:"v-t",value:('Add Layer'),expression:"'Add Layer'"}]}),_c('i',{class:_vm.$fa('layers')})])])])]),_vm._v(" "),(_vm.languages)?_c('li',{staticClass:"nav-lang",attrs:{"id":"g3w-nav-language"}},[_c('button',{staticStyle:{"display":"flex","gap":"5px"},attrs:{"type":"button","commandfor":"nav-lang-dialog","command":"show-modal"}},[_c('img',{attrs:{"src":_vm.urls.staticurl +'img/flags/' + _vm.language.toLowerCase() + '.png',"width":"24","height":"16","alt":""}}),_vm._v("\n          "+_vm._s(_vm.languages.find(function (l) { return l[0] === _vm.language; }).at(1))+"\n          "),_c('i',{staticClass:"triangle",staticStyle:{"margin-top":"8px"}})]),_vm._v(" "),_c('dialog',{attrs:{"id":"nav-lang-dialog"},on:{"click":function($event){$event.target === $event.target.closest('dialog') && $event.target.closest('dialog').close()}}},[_c('form',{staticStyle:{"display":"grid","grid-template-columns":"repeat(auto-fill, minmax(120px, 1fr))","gap":"10px","user-select":"none"},attrs:{"method":"dialog"}},_vm._l((_vm.languages),function(lang){return _c('label',{key:lang[0],staticStyle:{"cursor":"pointer","text-align":"left"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.language),expression:"language"}],staticStyle:{"pointer-events":"none","margin-right":"8px"},attrs:{"type":"radio"},domProps:{"value":lang[0],"checked":_vm._q(_vm.language,lang[0])},on:{"click":function($event){$event.target.closest('dialog').close()},"change":function($event){_vm.language=lang[0]}}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.urls.staticurl +'img/flags/' + lang[0].toLowerCase() + '.png',"width":"24","height":"16","alt":lang[0].toLowerCase()}}),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s(lang[1]))])])}),0)])]):_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('aside',[_c('div',{staticClass:"main-sidebar no-print",class:{ iframe: _vm.iframe, 'g3w-disabled': _vm.disabled }},[_c('div',{attrs:{"id":"disable-sidebar"}}),_vm._v(" "),_c('div',{staticClass:"g3w-sidebarpanel",attrs:{"hidden":_vm.panels.length <= 0}},[_c('div',{attrs:{"id":"g3w-sidebarpanel-header-placeholder"}},[_c('div',{staticStyle:{"display":"flex","margin-bottom":"5px"},style:({ justifyContent: _vm.app.sidebar.title ? 'space-between' : 'flex-end' })},[(_vm.title)?_c('h4',{directives:[{name:"t",rawName:"v-t",value:(_vm.title),expression:"title"}],staticStyle:{"display":"inline-block","font-weight":"bold"}}):_vm._e(),_vm._v(" "),_c('div',[(_vm.panels.length > 1)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip",value:('back'),expression:"'back'"}],staticClass:"g3w-span-button close-pane-button",attrs:{"data-placement":"left"},on:{"click":function($event){$event.stopPropagation();return _vm.closePanel.apply(null, arguments)}}},[_c('i',{staticClass:"panel-icon",class:_vm.$fa('arrow-left')})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"g3w-span-button close-pane-button",attrs:{"data-i18n-title":_vm.app.sidebar.tooltip_close || 'close',"data-placement":"right"},on:{"click":function($event){$event.stopPropagation();_vm.app.sidebar.btn_close && _vm.closeAllPanels()}}},[_c('i',{staticClass:"panel-icon",class:_vm.$fa('close'),style:({ opacity: _vm.app.sidebar.btn_close ? '1' : '0.7', cursor: _vm.app.sidebar.btn_close ? 'pointer' : 'not-allowed' })})])])])]),_vm._v(" "),_c('div',{staticClass:"g3w-sidebarpanel-placeholder",attrs:{"id":"g3w-sidebarpanel-placeholder"}})]),_vm._v(" "),_c('ul',{staticClass:"sidebar-menu",class:{ 'g3w-disabled': _vm.disabled },attrs:{"id":"g3w-sidebarcomponents","hidden":!_vm.showmainpanel},on:{"click":_vm.toggleSidebarItem}},[_c('li',{staticClass:"treeview sidebaritem",attrs:{"id":"metadata"}},[_c('a',{attrs:{"href":"#","data-toggle":"modal","data-target":"#modal-metadata"}},[_c('i',{class:_vm.$fa('file'),staticStyle:{"color":"#fff"}}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('Metadata'),expression:"'Metadata'"}],staticClass:"treeview-label"})])])])]),_vm._v(" "),_c('a',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip",value:('Sidebar menu'),expression:"'Sidebar menu'"}],staticClass:"sidebar-aside-toggle",class:{ 'g3w-disabled': _vm.disabled, 'iframe': _vm.iframe},staticStyle:{"z-index":"2"},attrs:{"href":"#","role":"button","data-placement":"right"},on:{"click":function($event){$event.preventDefault();return _vm.toggleSidebar.apply(null, arguments)}}})]),_vm._v(" "),_c('div',{staticClass:"content-wrapper",style:({ paddingTop: _vm.isIframe ? 0 : null })},[_c('transition',{attrs:{"name":"fade","duration":{ enter: 500, leave: 500 }}},[(_vm.usermessage.show)?_c('user-message',{attrs:{"title":_vm.usermessage.title,"subtitle":_vm.usermessage.subtitle,"id":_vm.usermessage.id,"message":_vm.usermessage.message,"draggable":_vm.usermessage.draggable,"closable":_vm.usermessage.closable,"duration":_vm.usermessage.duration,"position":_vm.usermessage.position,"autoclose":_vm.usermessage.autoclose,"textMessage":_vm.usermessage.textMessage,"size":_vm.usermessage.size,"type":_vm.usermessage.type,"icon-class":_vm.usermessage.iconClass},on:{"close-usermessage":_vm.closeUserMessage}},[(_vm.usermessage.hooks.header)?_c('template',{slot:"header"},[_c(_vm.usermessage.hooks.header,{tag:"component"})],1):_vm._e(),_vm._v(" "),(_vm.usermessage.hooks.body)?_c('template',{slot:"body"},[_c(_vm.usermessage.hooks.body,{tag:"component"})],1):_vm._e(),_vm._v(" "),(_vm.usermessage.hooks.footer)?_c('template',{slot:"footer"},[_c(_vm.usermessage.hooks.footer,{tag:"component"})],1):_vm._e()],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"g3w-view map",class:("split-" + (_vm.state.split)),style:(_vm.styles.map),attrs:{"id":"g3w-view-map"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.has_panel),expression:"has_panel"}],class:("split-" + (_vm.state.split)),attrs:{"id":"resize-map-and-content"},on:{"mousedown":function($event){$event.stopPropagation();return _vm.onResize.apply(null, arguments)}}}),_vm._v(" "),_c('div',{attrs:{"id":"application-notifications"}},[_c('div',{class:{ 'g3w-hide': _vm.app.online },staticStyle:{"color":"#999"}},[_c('i',{class:_vm.$fa('wifi')}),_vm._v(" "),_c('b',{staticStyle:{"font-size":"0.4em"}},[_vm._v("offline")])]),_vm._v(" "),_c('div',{class:{ 'skin-color': true, 'g3w-hide': !_vm.app.download }},[_c('bar-loader',{attrs:{"loading":true}}),_vm._v(" "),_c('i',{class:_vm.$fa('download'),staticStyle:{"padding":"3px"}}),_vm._v(" "),_c('b',{staticStyle:{"font-size":"0.35em"}},[_vm._v("download")])],1),_vm._v(" "),_c('div',{class:{ 'g3w-hide': 0 === _vm.app.plugins.length },staticStyle:{"color":"#994b10"}},[_c('bar-loader',{attrs:{"loading":true}}),_vm._v(" "),_c('i',{class:_vm.$fa('tools')}),_vm._v(" "),_c('b',{staticStyle:{"font-size":"0.4em"}},[_vm._v("plugins")])],1)])]),_vm._v(" "),_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.content.disabled),expression:"state.content.disabled"}],staticClass:"g3w-view content",class:("split-" + (_vm.state.split)),style:(_vm.styles.content),attrs:{"id":"g3w-view-content"}},[(_vm.breadcrumb.length > 1)?_c('section',{ref:_vm.breadcrumb,staticClass:"content_breadcrumb"},_vm._l((_vm.breadcrumb),function(crumb,index){return _c('span',{key:crumb.title},[_c('span',{directives:[{name:"t",rawName:"v-t",value:(crumb.text ? null : crumb.title),expression:"crumb.text ? null : crumb.title"}],staticClass:"skin-color-dark",style:({fontWeight: _vm.isNotLastCrumb(index) ? 'bold' : 'normal'})},[(crumb.text)?_c('span',[_vm._v(" "+_vm._s(crumb.title)+" ")]):_vm._e()]),_vm._v(" "),(_vm.isNotLastCrumb(index))?_c('span',{staticStyle:{"font-weight":"bold","margin":"3px 0"}},[_vm._v("/")]):_vm._e()])}),0):_vm._e(),_vm._v(" "),((_vm.showtitle && _vm.contentTitle) || _vm.previousTitle || _vm.state.content.closable)?_c('div',{staticClass:"close-panel-block",staticStyle:{"display":"flex","justify-content":"space-between"}},[(_vm.previousTitle)?_c('div',{staticClass:"g3w_contents_back g3w-long-text"},[('back' === _vm.backOrBackTo )?_c('div',{class:_vm.backOrBackTo},[_c('span',{staticClass:"action-button",class:_vm.$fa('back')}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('back'),expression:"'back'"}]})]):_c('div',{class:_vm.backOrBackTo,on:{"click":function($event){$event.stopPropagation();return _vm.gotoPreviousContent()}}},[_c('span',{staticClass:"action-button",class:_vm.$fa('back')}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('backto'),expression:"'backto'"}]}),_vm._v(" "),(!_vm.updatePreviousTitle)?_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.previousTitle),expression:"previousTitle"}]}):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.previousTitle && _vm.showtitle && _vm.contentTitle)?_c('div',{staticClass:"panel-title",class:{'mobile': _vm.isMobile()},style:([_vm.state.content.style.title])},[_c('b',{attrs:{"id":"contenttitle"}},[_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.contentTitle.text ? null : _vm.contentTitle.title),expression:"contentTitle.text ? null : contentTitle.title"}]},[(_vm.contentTitle.text )?_c('span',[_vm._v(_vm._s(_vm.contentTitle.title))]):_vm._e()]),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:(_vm.contentTitle.post_title),expression:"contentTitle.post_title"}]})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"g3-content-header-action-tools",staticStyle:{"display":"flex","align-items":"center","gap":".5ch","padding":"0 .5ch"}},[_vm._l((_vm.state.content.headertools),function(tool){return _c(tool,{tag:"component"})}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"space-between","font-size":"1em","padding":"0","align-self":"center","margin-left":"auto","cursor":"pointer"}},[(undefined !== _vm.state.split)?_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:bottom",value:('Enlarge / Reduce'),expression:"'Enlarge / Reduce'",arg:"bottom"}],staticClass:"action-button skin-color-dark",class:_vm.$fa(("resize-" + (_vm.state.split))),staticStyle:{"margin-right":"3px"},on:{"click":_vm.resizeFull}}):_vm._e()]),_vm._v(" "),_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:bottom",value:(("Dock to " + ('h' === this.state.split ? 'Bottom' : 'Right'))),expression:"`Dock to ${'h' === this.state.split ? 'Bottom' : 'Right'}`",arg:"bottom"}],staticClass:"action-button skin-color-dark fa fa-external-link-alt",staticStyle:{"cursor":"pointer","scale":".9"},style:({ transform: 'h' === _vm.state.split ? 'rotate(134deg)' : 'rotate(44deg)'}),on:{"click":_vm.splitContent}}),_vm._v(" "),(_vm.state.content.closable)?_c('i',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:bottom",value:('close'),expression:"'close'",arg:"bottom"}],staticClass:"action-button skin-color-dark fas fa-times",class:{'mobile': _vm.isMobile()},on:{"click":_vm.closeContent}}):_vm._e()],2)]):_vm._e(),_vm._v(" "),_c('bar-loader',{attrs:{"loading":_vm.state.content.loading}})],1)],1),_vm._v(" "),_c('catalog-context-menu'),_vm._v(" "),_c('cookie-law',{attrs:{"theme":"dark-lime","buttonText":_vm.cookie_law_buttonText}},[_c('div',{directives:[{name:"t",rawName:"v-t",value:('This website uses cookies to ensure you get the best experience on our website.'),expression:"'This website uses cookies to ensure you get the best experience on our website.'"}],attrs:{"slot":"message"},slot:"message"})]),_vm._v(" "),_c('Teleport',{attrs:{"to":"body"}},[_c('div',{staticClass:"modal fade modal-fullscreen",attrs:{"id":"modal-fullscreen","tabindex":"-1","role":"dialog","data-backdrop":"static","data-keyboard":"false","aria-labelledby":"modal-fullscreen","aria-hidden":"true"}}),_vm._v(" "),(!_vm.user && _vm.has_iframe_login)?_c('modal-login'):_vm._e(),_vm._v(" "),_c('modal-addlayer'),_vm._v(" "),_c('modal-changemap'),_vm._v(" "),_c('modal-metadata')],1)],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5e256101_0", { source: ".project_title[data-v-5e256101]{display:inline-flex;flex-direction:column;justify-content:center;height:100%;font-weight:700;color:#fff;max-height:50px;overflow:hidden;max-width:calc(100% - 150px)}.project_title>*[data-v-5e256101]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:700;margin:0}.project_title .h2[data-v-5e256101]{font-size:1.5em}.project_title h1[data-v-5e256101]{font-size:1.2em;padding-bottom:5px}#g3w-sidebarpanel-header-placeholder[data-v-5e256101]{overflow:hidden;line-height:14px;font-size:1.5em;min-height:35px;border-bottom:1px solid #fff;margin-bottom:5px}#disable-sidebar[data-v-5e256101]{display:none;position:absolute;background-color:rgba(0,0,0,.3);height:100%;width:100%;z-index:10}.content_breadcrumb[data-v-5e256101]{font-size:1.2em;padding:0 3px;border-radius:3px}.close-panel-block[data-v-5e256101]{overflow:hidden;margin-top:2px;margin-bottom:2px;font-size:1.4em}.g3w_contents_back[data-v-5e256101]{font-size:.8em}.g3w_contents_back[data-v-5e256101] :is(.backto,.back){display:inline-block;font-weight:700}.g3w_contents_back .backto[data-v-5e256101]{margin-top:5px;cursor:pointer}.user-header[data-v-5e256101]{padding:10px;text-align:center;border-bottom:1px solid rgba(0,0,0,.3)}.user-footer[data-v-5e256101]{padding:8px;display:flex;justify-content:space-between;flex-direction:column;gap:8px}.user-footer .btn-default[data-v-5e256101]{color:rgba(0,0,0,.75);border-color:currentColor;display:flex;flex-direction:row-reverse;justify-content:left;align-items:center;gap:8px}.user-footer .btn-default[data-v-5e256101]:not(:hover){background-color:transparent}.nav-user>.dropdown-menu[data-v-5e256101]{padding:1px 0 0 0;border:1px solid #aaa;border-top-width:0;border-radius:0;margin-top:0}i.triangle[data-v-5e256101]{border-color:#fff transparent transparent transparent;border-style:solid;border-width:5px 4px 0 4px;display:inline-block;margin:3px}.open i.triangle[data-v-5e256101]{border-color:transparent transparent #fff transparent;border-width:0 4px 5px 4px}@media (min-width:767px){.user-footer :is(.nav-sidebar,.nav-addlayer).btn-default[data-v-5e256101]{display:none}.project_title[data-v-5e256101]{margin-right:auto}}@media (max-width:767px){.nav-user>.dropdown-toggle[data-v-5e256101],.user-header[data-v-5e256101],body:not(.sidebar-open) .navbar-toggler~*[data-v-5e256101]{display:none!important}.navbar-nav[data-v-5e256101]{flex-direction:column}.user-footer .btn-default[data-v-5e256101]{padding:10px}.user-footer[data-v-5e256101]{background-color:transparent;border:none}.nav-user>ul[data-v-5e256101]{display:block;position:static;float:none;border:none;background-color:transparent}.nav-user .btn[data-v-5e256101]{color:#fff!important}.nav-user>.dropdown-menu[data-v-5e256101]{border:none}}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-5e256101"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "App.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__